import React from 'react';
import Modal from '../../component/Inc/Modal';
function PopSpecialMember(props) {
  const {open, close} = props;
  return (
    <Modal open={open} close={close} type="com_input">
      <h2 className="pop_tit">특별회원</h2>
      <div className="content_container scroll">
        <section className="search search_top">
          <input type="search" placeholder="학생명 검색" className="input s type_search" />
          <button className="com_btn gray ws s icon_search"></button>
        </section>
        <hr className="com_divider" />
        <ul className="com_input_sec">
          <li className="input_row">
            <div className="tit_field">학생명</div>
            <div className="input_field">
              <input type="text" className="input" placeholder="김학생102" />
            </div>
          </li>
          <li className="input_row">
            <div className="tit_field">전화번호</div>
            <div className="input_field">
              <input type="text" className="input" placeholder="010-2323-2323" />
            </div>
          </li>
          <li className="input_row">
            <div className="tit_field">성별 / 나이</div>
            <div className="input_field">
              <input type="text" className="input" placeholder="남 / 2009" />
            </div>
          </li>
          <li className="input_row">
            <div className="tit_field">지역</div>
            <div className="input_field">
              <input type="text" className="input" placeholder="서울/강남구" />
            </div>
          </li>
          <li className="input_row full">
            <div className="tit_field">학교</div>
            <div className="input_field">
              <input type="text" className="input" placeholder="서울고" />
            </div>
          </li>
          <li className="input_row">
            <div className="tit_field">교사</div>
            <div className="input_field">
              <input type="text" className="input" placeholder="김교사103" />
            </div>
          </li>
          <li className="input_row">
            <div className="tit_field">담임</div>
            <div className="input_field">
              <input type="text" className="input" placeholder="김담임105" />
            </div>
          </li>
          <li className="input_row full">
            <textarea className="textarea" placeholder="특별회원 사유 입력"></textarea>
          </li>
        </ul>
      </div>
      <div className="btn_container">
        <button className="com_btn orange xs">추가</button>
      </div>
    </Modal>
  );
}

export default PopSpecialMember;
